<header class="navbar navbar-header navbar-header-fixed">
  <a href="" id="mainMenuOpen" class="burger-menu"><i data-feather="menu"></i></a>
  <!-- <a href="" id="filemgrMenu" class="burger-menu d-lg-none"><i data-feather="arrow-left"></i></a> -->
  <div class="navbar-brand">
    <!-- <a href="javascript:void(0)" class="df-logo">Consorcio<span>Jurídico</span></a> -->
    <!-- <a href="javascript:void(0)" class="df-logo">Voices</a> -->
    <img src="/assets/img/Voices_Logo_Full.png" class="img-fluid" alt="" />
  </div><!-- navbar-brand -->
  <div id="navbarMenu" class="navbar-menu-wrapper">
    <div class="navbar-menu-header">
      <a href="javascript:void(0)" class="df-logo">Consorcio<span>Jurídico</span></a>
      <!-- <a href="javascript:void(0)" class="df-logo">Voices</a> -->
      <a id="mainMenuClose" href=""><i data-feather="x"></i></a>
    </div><!-- navbar-menu-header -->
    <ul class="nav navbar-menu">
      <li class="nav-item" routerLinkActive="active" *ngIf="hasAuth('dashboard')" ><a  routerLink="/dashboard" class="nav-link">Dashboard</a></li>
      <li class="nav-item" routerLinkActive="active" *ngIf="hasAuth('reportes')" ><a  routerLink="/reports" class="nav-link">Reportes</a></li>
      <li class="nav-item" routerLinkActive="active" *ngIf="hasAuth('audios')" ><a  routerLink="/file-manager" class="nav-link">Archivos</a></li>
      <li class="nav-item" routerLinkActive="active" *ngIf="hasAuth('usuarios')" ><a [routerLink]="['/users']" class="nav-link">Usuarios</a></li>
      <li class="nav-item" routerLinkActive="active" *ngIf="hasAuth('areas')" ><a [routerLink]="['/areas']" class="nav-link">Áreas</a></li>
      <li class="nav-item" routerLinkActive="active" *ngIf="hasAuth('perfiles')" ><a [routerLink]="['/profiles']" class="nav-link">Perfiles</a></li>
      <li class="nav-item" routerLinkActive="active" *ngIf="hasAuth('cedulas')" ><a [routerLink]="['/cedulas']" class="nav-link">Cédulas</a></li>
    </ul>
  </div><!-- navbar-menu-wrapper -->
  <div class="navbar-right">

    <nav aria-label="breadcrumb">
      <ol class="breadcrumb breadcrumb-style1 mg-b-0">
        <li class="breadcrumb-item active" aria-current="page">{{ session.completeName }}</li>
        <li class="breadcrumb-item active" aria-current="page">{{ session.namePerfil }}</li>
        <li class="breadcrumb-item active" aria-current="page">{{ session.nameArea }}</li>
        <li class="breadcrumb-item active" aria-current="page"  data-toggle="tooltip" data-placement="bottom" title="Minutos restantes"><i class="fas fa-box-open"></i> {{ minutes | number:'1.0-0' }}</li>
      </ol>
    </nav>

    <div class="dropdown dropdown-profile">
      <a href="" class="dropdown-link" data-toggle="dropdown" data-display="static">
        <div class="avatar avatar-sm avatar-center"><img src="/assets/img/icon-user.png" class="rounded-circle" alt=""></div>
      </a><!-- dropdown-link -->

      <div class="dropdown-menu dropdown-menu-right tx-13">
        <!-- <div class="avatar avatar-lg mg-b-15"><img src="/assets/img/icon-user.png" class="rounded-circle" alt=""></div> -->
        <!-- <h6 class="tx-semibold mg-b-5">Luis Zamudio</h6>
        <p class="mg-b-25 tx-12 tx-color-03">Administrador</p> -->
        <a href="javascript:void(0)" class="dropdown-item" (click)="logout()"><i data-feather="log-out"></i>Cerrar sesión</a>
      </div><!-- dropdown-menu -->
    </div><!-- dropdown -->
  </div><!-- navbar-right -->
</header><!-- navbar -->
